import './instance';

// register create function for bundleid
Oskari.bundle('register', () => Oskari.clazz.create('Oskari.mapframework.bundle.register.RegisterBundleInstance'));